import axios from "axios"
import baseURL from "../configs/api"

export const getDashboardBookingsByBranchId = (branchId: number, dateType: string, startDate: string, endDate: string, tenantId: string) => {
    return getFetch(`DashboardBookings/GetDashboardBookingsByBranchId`, tenantId, { branchId, dateType, pickupDate: startDate, returnDate: endDate });
}

export const getDashboardBooking = (dateType: string, startDate: string, endDate: string, tenantId: string) => {
    return getFetch(`DashboardBookings`, tenantId, { dateType, pickupDate: startDate, returnDate: endDate });
}

const getFetch = (url: string, tenantId: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            'X-Tenant-ID': tenantId,
            "Content-Type": "application/json"
        },
        params: params
    }).then(response => response.data);
}